/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { UserCatalogDto } from './UserCatalogDto';
import {
    instanceOfUserCatalogDto,
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';

/**
 * @type BeamAnalysisWorkResultDtoCreatorUser
 * 
 * @export
 */
export type BeamAnalysisWorkResultDtoCreatorUser = UserCatalogDto;


export function BeamAnalysisWorkResultDtoCreatorUserFromJSON(json: any): BeamAnalysisWorkResultDtoCreatorUser {
    return BeamAnalysisWorkResultDtoCreatorUserFromJSONTyped(json, false);
}

export function BeamAnalysisWorkResultDtoCreatorUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamAnalysisWorkResultDtoCreatorUser {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...UserCatalogDtoFromJSONTyped(json, true) };
    return  UserCatalogDtoFromJSONTyped(json, true);
}

export function BeamAnalysisWorkResultDtoCreatorUserToJSON(value?: BeamAnalysisWorkResultDtoCreatorUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfUserCatalogDto(value)) {
        return UserCatalogDtoToJSON(value as UserCatalogDto);
    }

    return {};
}

/**
 * Check if a given object implements the BeamAnalysisWorkResultDtoCreatorUser interface.
 */
export function instanceOfBeamAnalysisWorkResultDtoCreatorUser(value: any): value is BeamAnalysisWorkResultDtoCreatorUser {
    if (instanceOfUserCatalogDto(value)) return true;
    return false;
}

